import { render, staticRenderFns } from "./CreateBusinessBranchAddressStepper.vue?vue&type=template&id=6fd845b5&"
import script from "./CreateBusinessBranchAddressStepper.vue?vue&type=script&lang=js&"
export * from "./CreateBusinessBranchAddressStepper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports